import styled from 'styled-components';

import PlayCanvasProject from 'components/PlayCanvasProject';

export default styled(PlayCanvasProject)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
